import { useMutation } from "@tanstack/react-query";
import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as LogoSVG } from "../../assets/svg/akinrobotics-logo.svg";
//APIs
import { login } from "../../services/ApiServices";
export default function Login() {
  const history = useHistory();
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const usernameRef = useRef(null);

  useEffect(() => {
    usernameRef.current?.focus();
  }, []);

  if (!!localStorage.getItem("jwtHeader")) {
    history.push("/home");
  }

  const mutation = useMutation(login, {
    onSuccess: (value) => {
      const token = value.data.token;
      const guid = value.data.guid;
      if (guid.Check === undefined) {
        console.log("guid", guid);
        //dispact(SetGuid(guid));
        localStorage.setItem("guid", guid);
        localStorage.setItem("jwtHeader", token);
        history.push("/home");
      } else {
        toast.error(
          "Girilmiş olan kullanıcı verileri sistemdekiler ile eşleşmemektedir.",
          { position: "top-center" }
        );
      }
    },
    onError: (error) => {
      // Hata durumunu burada ele alıyoruz
      console.error("Login error: ", error);
      toast.error(
        "Giriş işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.",
        { position: "top-center" }
      );
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({
      username,
      password,
    });
  };

  return (
    <>
      <div
        className="h-screen w-full fixed overflow-hidden bg-center bg-gradient-to-tr from-white to-gray-200"
        style={{
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex m-auto flex-col items-center justify-center  mx-auto w-full px-6 py-6 h-full lg:py-0 backdrop-blur-xl">
          <div className="md:flex flex items-center justify-center   text-2xl  font-semibold text-gray-900 ">
            <LogoSVG className="md:h-20 md:w-28 h-10  " />
          </div>
          <div className="w-full  bg-white rounded-lg shadow  md:mt-0 sm:max-w-md xl:p-0 mt-2   ">
            <form onSubmit={handleSubmit} className="p-8 space-y-4 md:space-y-6 sm:p-8">
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                  Kullanıcı Adı
                </label>
                <input
                  ref={usernameRef}
                  value={username}
                  onChange={(e) => setusername(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                  placeholder="akinrobotics"
                  required
                  type="text"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                  Şifre
                </label>
                <input
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                  required
                  type="password"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
              >
                Giriş Yap
              </button>
              <p className="text-sm font-light text-gray-500 ">
                Copyright © 1995 - 2026 AKINROBOTICS | İnsana Değer - Her Hakkı
                Saklıdır
              </p>
            </form>
          </div>
        </div>
      </div>
      <div className="md:hidden flex">
        <LogoSVG className="h-20 w-28  " />
      </div>
    </>
  );
}